import { Adapter as t, getAdapter as o } from "../../../adapter.js";
import { TierConfigurationAdapter as i } from "./tierConfiguration/tierConfiguration.adapter.js";
import { TierModel as n } from "./tier.model.js";
import { AudienceAdapter as a } from "../../audience/audience.adapter.js";
class s extends t {
  adapt(e) {
    const r = o(a);
    return new n({
      id: e.id,
      code: e.code,
      name: e.name,
      loyaltyProgramme: e.loyalty_programme,
      status: e.status,
      endDate: t.toOptionalDate(e.end_date),
      startDate: t.toOptionalDate(e.start_date),
      audience: e.audience ? e.audience.map(r.adapt) : [],
      configuration: e.configuration ? o(i).adapt(e.configuration) : void 0
    });
  }
  serialize(e) {
  }
}
export {
  s as TierAdapter
};
//# sourceMappingURL=tier.adapter.js.map
